import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { IconButton, Typography } from '@mui/material';
import React from 'react';

interface CandidateTableHeaderProps {
  searchValue: string;
  onSearchChange: (value: string) => void;
  goBack: () => void;
}

const CandidateTableHeader: React.FC<CandidateTableHeaderProps> = ({
  searchValue,
  onSearchChange,
  goBack,
}) => {
  return (
    <div className="job-queue-header">
      {/* Search and Actions */}
      <div className="job-queue-actions">
        <div
          style={{
            alignItems: 'center',
            display: 'flex',
          }}>
          <IconButton
            sx={{
              '&:hover': {
                backgroundColor: '#f3f4f6',
              },
              border: '1px solid #dddddd',
              borderRadius: '6px',
              height: '32px',
              marginRight: '16px',
              padding: '4px',
              width: '32px',
            }}
            onClick={() => goBack()}>
            <ArrowBackIcon sx={{ color: '#3f3f3f', fontSize: '16px' }} />
          </IconButton>
          <Typography
            sx={{
              color: '#242424',
              fontFamily: 'Inter',
              fontSize: '16px',
              fontWeight: 600,
              lineHeight: '22px',
            }}>
            More
          </Typography>
        </div>

        <div className="action-buttons">
          <div className="search-container">
            <input
              type="text"
              placeholder="Search"
              value={searchValue}
              onChange={(e) => onSearchChange(e.target.value)}
              className="job-queue-search"
              style={{
                border: '1px solid #e5e7eb',
                borderRadius: '6px',
                fontFamily: 'Inter',
                fontSize: '14px',
                fontWeight: 400,
                height: '32px',
                outline: 'none',
                padding: '8px 12px',
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CandidateTableHeader;
